'use strict';
import React from 'react';

/**
 * Slider Mark.
 *
 * Usage:
 *
 * ```Javascript
 * < />
 * ```
 *
 * @extends {React.Component}
 * @property {Numeric} MarkPosition Renders the slider Mark line to the specified value between 0 - 100.
 */
class Mark extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children } = this.props;
    return (
      <div className="SliderMark">
        <div className="TextMark">
          { children }
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Mark component
 */
Mark.propTypes = {

};

Mark.defaultProps = {

};

export default Mark;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/slider/mark.jsx